import "./App.css";
import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";

function App({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        className="App"
        style={{
          background: theme.palette.background.default,
          minHeight: "100vh",
          color: theme.palette.text.primary,
        }}
      >
        {children}
      </div>
    </ThemeProvider>
  );
}

export default App;
